export const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT
export const APP_SECRET = process.env.REACT_APP_PAYPAL_SECRET